import { EventBus } from '@kulee/helper'

export default EventBus
